import { useAuth } from '../../context/AuthContext';
import useExtensionAutoConnect from '../../hooks/useExtensionAutoConnect';
import useExtensionConfigProvisioning from '../../hooks/useExtensionConfigProvisioning';

/**
 * Headless. Provisions the Chrome extension from the signed-in website session
 * so students never copy a token (AD-EA-1) or edit chrome.storage.local (AD-FP-1).
 *
 * The two concerns have different lifecycles and stay independent: the token is
 * issued only when the extension has none, while configuration refreshes on its
 * own cadence so a feature disabled in the console switches itself off.
 *
 * Students only — Extension Tokens are issued to `student` accounts.
 */
export default function ExtensionAutoConnect() {
  const { isAuthenticated, isStudent } = useAuth();
  const enabled = Boolean(isAuthenticated && isStudent);

  const { provisionNow } = useExtensionConfigProvisioning({ enabled });
  useExtensionAutoConnect({ enabled, onProvisioned: provisionNow });

  return null;
}
